<div *ngIf="loading" class="rounded-xl border border-gray-200 p-5 mb-4 text-center bg-gradient-to-br from-gray-50 to-white">
    <i class="fas fa-spinner fa-spin text-gray-400 text-lg"></i>
    <span class="text-sm text-gray-400 ml-2">Cargando rewards...</span>
</div>

<div *ngIf="!loading && summary && view" class="rounded-xl overflow-hidden mb-4 shadow-sm border" [ngClass]="view.style.card">
    <!-- Header con tier badge -->
    <div class="px-4 pt-4 pb-3">
        <div class="flex items-center justify-between">
            <div class="flex items-center gap-2.5">
                <div class="w-9 h-9 rounded-lg flex items-center justify-center" [ngClass]="view.style.iconBg">
                    <i class="fas text-lg" [ngClass]="view.style.icon"></i>
                </div>
                <div>
                    <div class="text-sm font-bold" [ngClass]="view.style.text">{{ view.tierName || 'Sin nivel' }}</div>
                    <div class="text-[11px] text-gray-500">Programa de Fidelización</div>
                </div>
            </div>
            <div *ngIf="summary.member_since" class="text-[10px] text-gray-400 text-right">
                Desde {{ summary.member_since | date:'MMM yyyy' }}
            </div>
        </div>
    </div>

    <!-- Puntos XP y WALLET -->
    <div class="px-4 pb-3">
        <div class="grid grid-cols-2 gap-2.5">
            <div class="bg-white/70 backdrop-blur rounded-lg p-3 border border-white/50">
                <div class="flex items-center gap-1.5 mb-1">
                    <i class="fas fa-bolt text-amber-500 text-xs"></i>
                    <span class="text-[11px] font-medium text-gray-500 uppercase tracking-wide">Experiencia</span>
                </div>
                <div class="text-xl font-bold text-gray-800 tabular-nums">{{ summary.xp_balance | number }}</div>
                <div class="text-[10px] text-gray-400 font-medium">XP</div>
            </div>
            <div class="bg-white/70 backdrop-blur rounded-lg p-3 border border-white/50">
                <div class="flex items-center gap-1.5 mb-1">
                    <i class="fas fa-wallet text-emerald-500 text-xs"></i>
                    <span class="text-[11px] font-medium text-gray-500 uppercase tracking-wide">Canjeables</span>
                </div>
                <div class="text-xl font-bold text-gray-800 tabular-nums">{{ summary.wallet_balance | number:'1.2-2' }}</div>
                <div class="text-[10px] text-gray-400 font-medium">Beneficios</div>
            </div>
        </div>
    </div>

    <!-- Barra de progreso segmentada: un tramo por nivel de la escalera vigente -->
    <div *ngIf="view.segments.length" class="px-4 pb-4">
        <div class="bg-white/60 backdrop-blur rounded-lg p-3 border border-white/50">
            <div class="flex gap-1 mb-2">
                <div *ngFor="let segment of view.segments" class="flex-1 relative">
                    <div class="h-2.5 bg-gray-200 overflow-hidden"
                         [class.rounded-l-full]="segment.isFirst" [class.rounded-r-full]="segment.isLast">
                        <div class="h-full transition-all duration-700" [ngClass]="segment.barClass"
                             [style.width.%]="segment.fillPct"></div>
                    </div>
                    <div class="text-[9px] text-gray-400 mt-0.5 text-center">{{ segment.name }}</div>
                </div>
            </div>

            <div *ngIf="view.nextTierName" class="flex items-center justify-between text-[11px] mt-1">
                <span class="text-gray-500">
                    <i class="fas fa-arrow-up text-emerald-500 mr-1"></i>
                    Próximo: <strong>{{ view.nextTierName }}</strong>
                </span>
                <span class="font-semibold tabular-nums" [ngClass]="view.style.accent">
                    <ng-container *ngIf="view.xpRemaining > 0; else xpReached">{{ view.xpRemaining | number }} XP restantes</ng-container>
                    <ng-template #xpReached>XP alcanzado</ng-template>
                </span>
            </div>
            <div *ngIf="view.isMaxTier" class="text-[11px] text-center mt-1 font-medium" [ngClass]="view.style.accent">
                <i class="fas fa-crown mr-1"></i> Nivel máximo alcanzado
            </div>
        </div>
    </div>
</div>

<div *ngIf="!loading && !summary"
     class="rounded-xl border-2 border-dashed border-gray-200 bg-gradient-to-br from-gray-50 to-white p-5 mb-4 text-center">
    <div class="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center mx-auto mb-2">
        <i class="fas fa-gift text-gray-300 text-xl"></i>
    </div>
    <p class="text-sm text-gray-500 font-medium mb-0">Sin actividad en Rewards</p>
    <p class="text-[11px] text-gray-400 mt-0.5">Los puntos se acumulan al pagar cuotas</p>
</div>
